import { LOAD_REPORT_FINISHED } from 'store/actions/reportAction'

import omit from 'lodash/omit'

const INITIAL_STATE = {
  countryCode: null,
  integratorLeadId: null,
  integratorName: null,
  integratorEmail: null,
  integratorFullName: null,
  integratorPhone: null,
  integratorLogo: null,
  integratorProfilePicture: null,
  integratorIntro: null,
  recipientMessage: null,
  orderedDate: null,
  propertyAddress: null,
  reportId: null,
  expirationDate: null
}

export default function reportReducer(state = INITIAL_STATE, action = {}) {
  // TODO: Change to switch statement when adding more conditions
  if (action.type === LOAD_REPORT_FINISHED) {
    return { ...state, ...omit(action.payload, ['reportLink', 'preference']) }
  } else {
    return state
  }
}
